import { AdvanceScreensContent, Query } from '@varo/graphql-schema-types';
import EligibilityScreenContent from 'services/graphql/queries/advance/AdvanceEligibilityScreenContent';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useQuery } from 'urql';

interface EligibilityContentResult {
  result: AdvanceScreensContent | null;
  errorModel?: {
    screenType: ErrorScreenType;
    messageHeadline: string;
    messageBody: string;
    buttons: {
      primaryButton: {
        title: string;
        onPress: () => void;
      };
    };
  } | null;
  loading: boolean;
  refetch: () => void;
}

const useGetEligibilityScreenContent = (): EligibilityContentResult => {
  const [{ data, fetching, error }, refetch] = useQuery<Query>({
    query: EligibilityScreenContent,
    requestPolicy: 'network-only',
  });

  const advanceScreenContentData = data?.advanceScreensContent ?? null;

  const { defaultTitle, defaultMessage, retryButtonTitle } =
    useDefaultErrorStrings();

  const errorModel = error
    ? {
        screenType: ErrorScreenType.Error,
        messageHeadline: defaultTitle,
        messageBody: defaultMessage,
        buttons: {
          primaryButton: {
            title: retryButtonTitle,
            onPress: () => {
              void refetch();
            },
          },
        },
      }
    : null;

  return {
    result: advanceScreenContentData,
    loading: fetching,
    errorModel,
    refetch,
  };
};

export default useGetEligibilityScreenContent;
